import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';

import { SettingsProvider } from '@/contexts/settings-context';
import { AuthProvider } from '@/features/auth/contexts/auth-provider';
import { AbilityProvider } from '@/permissions/can';
import { useUserStore } from '@/store/user-store';

interface Props {
  children: ReactNode;
}

const queryClient = new QueryClient();

const Providers = ({ children }: Props) => {
  const userId = useUserStore(state => state.userId);
  const userRole = useUserStore(state => state.userRole);
  const isSSO = useUserStore(state => state.isSSO);

  return (
    <>
      <HelmetProvider>
        <SettingsProvider>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <AbilityProvider role={userRole || 'admin'} userId={userId || ''} isSSO={isSSO}>
                {children}
                <Toaster position="top-center" />
              </AbilityProvider>
            </AuthProvider>
          </QueryClientProvider>
        </SettingsProvider>
      </HelmetProvider>
      <TanStackRouterDevtools position="bottom-right" />
    </>
  );
};

export default Providers;
